import React from "react";
import { useScaffold } from "../../scaffold";

export const NoContextError: React.FC = () => {
  const scaffold = useScaffold();
  const PageBody = scaffold.page.pageBody;
  const Title = scaffold.page.title;
  const Subtitle = scaffold.page.subtitle;

  return (
    <PageBody>
      <div className="absolute top-1/2 left-0 w-full -translate-y-1/2 px-4 gap-4 flex flex-col text-left">
        <div className="flex flex-col gap-2">
          <Title>No information could be found about your energy plan</Title>
          <Subtitle>
            We were unable to locate your account. Please try the link that
            brought you here again or reach out to your energy provider for
            help.
          </Subtitle>
        </div>
      </div>
    </PageBody>
  );
};
